<template lang="pug">
button.controller-close(:class="getThemeClass", @click="close")
  icon.controller-close__icon(name="close")
</template>

<script>
export default {
  name: "ControllerClose",
  props: {
    theme: {
      type: String,
      default: "black", // black, white
    },
  },
  computed: {
    getThemeClass() {
      return [`controller-close--${this.theme}`];
    },
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeyDown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeyDown);
  },
  methods: {
    handleKeyDown(e) {
      if (e.keyCode === 27) {
        this.close();
      }
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "../style/controller-close";
</style>
